import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';

class WhatIfTaskEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'whatIfTaskEditControl';
	}

	/**
	 * @param {Object} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, { dto })
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new WhatIfTaskEditService();
